import { FcmMessageDataInterface } from '@actassa/api';

export class SetNotificationData {
    public static readonly type = '[RootState] Set notification data';

    constructor(public payload: FcmMessageDataInterface) {}
}
